import { useState } from "react"
import { FiltersType } from "components/Shared/GlobalFilter/context/interfaces"

const useConfirmedFilters = <T>(filters: FiltersType, calendarInterval: T) => {
	const [calendarDateConfirmed, setCalendarDateConfirmed] = useState<T>({} as T)
	const [confirmedFilters, setConfirmedFilters] = useState<FiltersType>(
		{} as FiltersType
	)

	const confirmFilters = () => {
		setConfirmedFilters(filters)
		setCalendarDateConfirmed(calendarInterval)
	}

	const filtersString = JSON.stringify({ ...filters, ...calendarInterval })
	const confirmedFiltersString = JSON.stringify({
		...confirmedFilters,
		...calendarDateConfirmed,
	})
	const hasFilterChangesSinceLastUpdate =
		filtersString !== confirmedFiltersString

	return {
		confirmFilters,
		calendarDateConfirmed,
		confirmedFilters,
		hasFilterChangesSinceLastUpdate,
	}
}
export default useConfirmedFilters
